import * as React from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { space } from 'styled-system';

const SVG = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 5a3 3 0 013-3h8a3 3 0 013 3v6a3 3 0 01-3 3H4a3 3 0 01-3-3V5zm3-1.5h8A1.5 1.5 0 0113.5 5v.376L8 7.21 2.5 5.376V5A1.5 1.5 0 014 3.5zM2.5 6.957V11A1.5 1.5 0 004 12.5h8a1.5 1.5 0 001.5-1.5V6.957L8 8.791 2.5 6.957z"
      fill="#000"
    />
  </svg>
);

const SIZE = 16;
const CAN_SET_COLOR = true;
const SvgMessage16 = styled(SVG)`
  min-height: ${SIZE}px;
  min-width: ${SIZE}px;
  max-height: ${SIZE}px;
  max-width: ${SIZE}px;
  cursor: ${(p) => (p.$pointer || p.onClick ? 'pointer' : 'default')};
  ${(p) =>
    CAN_SET_COLOR &&
    css`
      path {
        fill: ${themeGet(`colors.${p.color}`, p.color)};
      }
    `}
  ${space}
`;
export default SvgMessage16;
